/**
 * Brand data transfer object
 */
export class BrandDto {
  constructor(data = {}) {
    this.id = data.id || null;
    this.name = data.name || '';
    this.description = data.description || '';
    this.createdAt = data.createdAt || null;
    this.updatedAt = data.updatedAt || null;
  }

  /**
   * Creates a BrandDto instance from JSON API response
   * @param {Object} json - JSON object from API
   * @returns {BrandDto}
   */
  static fromJSON(json) {
    if (!json) return null;
    
    return new BrandDto({
      id: json.id,
      name: json.name,
      description: json.description || '',
      createdAt: json.createdAt,
      updatedAt: json.updatedAt
    });
  }

  /**
   * Converts BrandDto to JSON for API requests
   * @returns {Object}
   */
  toJSON() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }
}

export default BrandDto;
